import classNames from 'classnames';
import React, { useEffect, useState } from 'react';
import { Collapse } from 'react-collapse';

import { getTranslation, keys } from '../../../../../Resources/Translations';
import { PriceDisplay } from '../../../../ReactComponents/PriceDisplay';
import { CartShippingInfoViewModel } from '../../ViewModels/CartShippingInfo/CartShippingInfoViewModel.csharp';

interface CartSummaryFreeDeliveryInfoV2Props {
    shippingInfo: CartShippingInfoViewModel;
    subTotalWithDiscountsIncludingHelfo: number;
    deliveryPriceCalculationInfo?: string;
    hideWhenExceeded?: boolean;
}

export const CartSummaryFreeDeliveryInfoV2 = (props: CartSummaryFreeDeliveryInfoV2Props) => {
    const [isDeliveryCalculationVisible, setIsDeliveryCalculationVisible] = useState<boolean>(false);

    useEffect(() => {
        if (props.shippingInfo?.cheapestMethodInfo?.amountLeftForFreeDelivery <= 0) {
            setIsDeliveryCalculationVisible(false);
        }
    }, [props.shippingInfo?.cheapestMethodInfo?.amountLeftForFreeDelivery]);

    if (!props.shippingInfo?.cheapestMethodInfo) return <></>;

    const { amountLeftForFreeDelivery } = props.shippingInfo.cheapestMethodInfo;
    const barValue = props.subTotalWithDiscountsIncludingHelfo / (amountLeftForFreeDelivery + props.subTotalWithDiscountsIncludingHelfo);
    const barPercentage = barValue < 1 ? barValue * 100 : 100;
    const thresholdExceeded = amountLeftForFreeDelivery <= 0;
    const showBar = barValue >= 1 ? 0 : 1;
    const hideContainer = props.hideWhenExceeded && thresholdExceeded;

    const toggleButtonOnClick = () => {
        setIsDeliveryCalculationVisible((prevState) => !prevState);
    };

    return (
        <>
            {Number.isFinite(amountLeftForFreeDelivery) && (
                <div className={classNames('CartSummaryFreeDeliveryInfo', hideContainer && 'CartSummaryFreeDeliveryInfo--Hidden')}>
                    <div>
                        <div className="CartSummaryFreeDeliveryInfo__Info">
                            {!thresholdExceeded ? (
                                <span className="CartSummaryFreeDeliveryInfo__AmountForFreeDelivery">
                                    <div>
                                        <span>
                                            {getTranslation(keys['cartSummary.freeDeliveryNeededAmount'])} <PriceDisplay price={amountLeftForFreeDelivery} />{' '}
                                        </span>
                                        <span>{getTranslation(keys['cartSummary.freeDeliveryGratis'])}</span>
                                    </div>
                                </span>
                            ) : (
                                <span className={classNames('CartSummaryFreeDeliveryInfo__AmountForFreeDelivery', 'CartSummaryFreeDeliveryInfo__CheckMark')}>
                                    {getTranslation(keys['cartSummary.freeDeliveryAchieved'])}
                                </span>
                            )}
                        </div>
                        <div
                            style={{
                                visibility: showBar ? 'visible' : 'hidden',
                                overflow: showBar ? '' : 'hidden',
                                marginTop: showBar ? `8px` : `0`,
                                maxHeight: showBar ? '500px' : 0,
                                transform: `scaleY(${showBar})`
                            }}
                            className="CartSummaryFreeDeliveryInfo__BarContainer"
                        >
                            <div style={{ width: `${barPercentage}%` }} className="CartSummaryFreeDeliveryInfo__Bar" />
                        </div>
                    </div>
                    {props.deliveryPriceCalculationInfo && (
                        <Collapse isOpened={!thresholdExceeded}>
                            <div className="CartSummaryFreeDeliveryInfo__MiddleSpace" />
                            <div className="CartSummaryFreeDeliveryInfo__LogicContainer">
                                <button
                                    className="CartSummaryFreeDeliveryInfo__LogicHeadingButton"
                                    onClick={toggleButtonOnClick}
                                    aria-expanded={isDeliveryCalculationVisible}
                                    aria-controls="CartSummaryFreeDeliveryInfoV2Logic"
                                    tabIndex={thresholdExceeded ? -1 : 0}
                                >
                                    <span className="CartSummaryFreeDeliveryInfo__LogicHeadingText">
                                        {getTranslation(keys['cartSummary.freeDeliveryCalculationHeading'])}
                                    </span>
                                    <div
                                        className={classNames(
                                            'CartSummaryFreeDeliveryInfo__ToggleIcon',
                                            isDeliveryCalculationVisible && 'CartSummaryFreeDeliveryInfo__ToggleIcon--Expanded'
                                        )}
                                    />
                                </button>
                                <Collapse isOpened={isDeliveryCalculationVisible}>
                                    <div className="CartSummaryFreeDeliveryInfo__LogicTextWrapper" id="CartSummaryFreeDeliveryInfoV2Logic">
                                        {props.deliveryPriceCalculationInfo}
                                    </div>
                                </Collapse>
                                <div
                                    className={classNames(
                                        'CartSummaryFreeDeliveryInfo__LogicPaddingBottom',
                                        isDeliveryCalculationVisible && 'CartSummaryFreeDeliveryInfo__LogicPaddingBottom--Visible'
                                    )}
                                />
                            </div>
                        </Collapse>
                    )}
                </div>
            )}
        </>
    );
};
